import API from "../axiosConfig";

export const getWorkingSchedules = async () => {
  try {
    const response = await API.get("/working-schedules");
    return response.data;
  } catch (error) {
    console.error("Error fetching working-schedules:", error);
    throw error;
  }
};

export const createWorkingSchedule = async (lineData) => {
  try {
    const response = await API.post("/working-schedules", lineData);
    return response.data;
  } catch (error) {
    console.error("Error creating working-schedules:", error);
    throw error;
  }
};

export const updateWorkingSchedule = async (lineId, lineData) => {
  try {
    const response = await API.put(`/working-schedules/${lineId}`, lineData);
    return response.data;
  } catch (error) {
    console.error("Error updating working-schedules:", error);
    throw error;
  }
};
